import React from "react";
import RegistrationSteps from "../../Components/howItWorks/RegistationStep";
import FundraiserStep from "../../Components/howItWorks/FundraiserStep";
import ManageFundraiser from "../../Components/howItWorks/ManageFundraiser";
import Cause from "../../Components/howItWorks/Cause";
import WhyUs from "../../Components/howItWorks/WhyUs";


const HowItWorks = () => {
  return (
    <>
    <RegistrationSteps/>
    <FundraiserStep/>
    <ManageFundraiser/>
    <Cause/>
    <WhyUs/>
   {/* // <div className="bg-white py-10 px-4 sm:px-8 lg:px-16">

  

    
      <div className="mt-12">
        <h2 className="text-2xl font-bold text-center mb-6">Success Stories</h2>
        <div className="space-y-6">
          {[
            {
              title: "You are the reason Suraj gets to live his dream",
              description:
                "Our son’s cancer had relapsed after 2.5 years of chemotherapy. Thanks to your donations & prayers, he underwent successful treatment & is recovering well. May God bless you all for saving his life!",
              author: "- Dhanasar (Father)",
            },
            {
              title: "Heroes like you helped my son win his battle",
              description:
                "Thanks to your generous donations, Afzal underwent a successful BMT to treat thalassemia major. We are eternally grateful to you all for gifting our little bundle of joy a second chance at life!",
              author: "- Reshma (Mother)",
            },
            {
              title: "My daughter finally gets to enjoy her childhood",
              description:
                "Your donations gave her a new lease on life! She underwent a successful liver transplant and is now enjoying her childhood. Words cannot express how grateful I am to you angels!",
              author: "- Prajakta (Mother)",
            },
            {
              title: "Amit and the world’s toughest cycling expedition",
              description:
                "Dr. Amit Samarth is the first Asian to qualify, contest and complete the Trans-Siberian Extreme Endurance Race. He successfully raised the amount needed for this once-in-a-lifetime adventure on Ketto.",
              author: "- Dr. Amit Samarth",
            },
          ].map((story, index) => (
            <div key={index} className="bg-white p-6 shadow-md rounded-md">
              <h3 className="text-xl font-semibold">{story.title}</h3>
              <p className="mt-2">{story.description}</p>
              <p className="mt-4 italic font-medium">{story.author}</p>
            </div>
          ))}
        </div>
      </div>
    </div> */}
    </>
    
  );
};

export default HowItWorks;
